import { Services } from '../services';

/**
 * Reports an element's rendered content box. A `ResizeObserver` rather than a measurement taken during
 * redraw: the panel dividers resize by writing a CSS custom property and deliberately skip the redraw, so
 * a render-time measurement would not see a drag until something unrelated repainted.
 */
export class ElementSizeTracker {
	private observer: ResizeObserver | null = null;
	private element: HTMLElement | null = null;

	constructor(private readonly onSize: (width: number, height: number) => void) {}

	/** Idempotent: Mithril recycles elements positionally, so this runs from `onupdate` as well as `oncreate`. */
	track(element: HTMLElement) {
		if (element === this.element) {
			return;
		}

		this.stop();
		this.element = element;
		this.observer = new Services.Window.window.ResizeObserver((entries) => {
			const entry = entries[entries.length - 1];
			if (entry != null) {
				this.onSize(entry.contentRect.width, entry.contentRect.height);
			}
		});
		this.observer.observe(element);
	}

	stop() {
		if (this.observer != null) {
			this.observer.disconnect();
			this.observer = null;
		}
		this.element = null;
	}
}
